import React from "react";
import GlobalStyle from "./globalStyles";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/HomePage/Home";
import { Footer } from "./components";
import Wrapper from "./components/Wrapper";
import Services from "./pages/Services/Services";
import Products from "./pages/Products/Products";
import Contact from "./pages/Contact/Contact";

function App() {
  return (
    <Router>
      <Wrapper>
        <GlobalStyle />
        <Navbar />
        <Routes>
          <Route path="/" exact Component={Home} />
          <Route path="/services" exact Component={Services} />
          <Route path="/products" exact Component={Products} />
          <Route path="/contact" exact Component={Contact} />
        </Routes>
        <Footer />
      </Wrapper>
    </Router>
  );
}

export default App;
